import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type NewTitleGraphqlFragment = { __typename?: 'NewTitlesEdge' } & Pick<Types.NewTitlesEdge, 'cursor'> & {
		newOffer?: Types.Maybe<
			{ __typename?: 'Offer' } & Pick<
				Types.Offer,
				| 'id'
				| 'standardWebURL'
				| 'retailPrice'
				| 'retailPriceValue'
				| 'lastChangeRetailPrice'
				| 'lastChangeRetailPriceValue'
				| 'lastChangePercent'
				| 'currency'
				| 'presentationType'
				| 'monetizationType'
				| 'newElementCount'
			> & {
					package: { __typename?: 'Package' } & Pick<
						Types.Package,
						'id' | 'packageId' | 'clearName' | 'shortName'
					>;
				}
		>;
		node:
			| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id' | 'objectId' | 'objectType'> & {
						likelistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						dislikelistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						seenlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						watchlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						content: { __typename?: 'MovieContent' } & Pick<
							Types.MovieContent,
							'title' | 'fullPath' | 'posterUrl' | 'isReleased'
						> & {
								scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
								upcomingReleases?: Types.Maybe<
									Array<
										{ __typename?: 'UpcomingRelease' } & Pick<
											Types.UpcomingRelease,
											'releaseDate' | 'releaseCountDown'
										> & {
												package?: Types.Maybe<
													{ __typename?: 'Package' } & Pick<Types.Package, 'id' | 'shortName'>
												>;
											}
									>
								>;
							};
						availableTo?: Types.Maybe<
							Array<
								{ __typename?: 'AvailableTo' } & Pick<
									Types.AvailableTo,
									'availableCountDown' | 'availableToDate'
								> & { package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'shortName'> }
							>
						>;
					})
			| ({ __typename?: 'Season' } & Pick<Types.Season, 'id' | 'objectId' | 'objectType'> & {
						show: { __typename?: 'Show' } & Pick<Types.Show, 'id' | 'objectId' | 'objectType'> & {
								content: { __typename?: 'ShowContent' } & Pick<Types.ShowContent, 'title'>;
								likelistEntry?: Types.Maybe<
									{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
								>;
								dislikelistEntry?: Types.Maybe<
									{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
								>;
								watchlistEntry?: Types.Maybe<
									{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
								>;
								seenState: { __typename?: 'ShowSeenState' } & Pick<Types.ShowSeenState, 'progress'>;
							};
						content: { __typename?: 'SeasonContent' } & Pick<
							Types.SeasonContent,
							'seasonNumber' | 'title' | 'fullPath' | 'posterUrl' | 'isReleased'
						> & {
								scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
								upcomingReleases?: Types.Maybe<
									Array<
										{ __typename?: 'UpcomingRelease' } & Pick<
											Types.UpcomingRelease,
											'releaseDate' | 'releaseCountDown'
										> & {
												package?: Types.Maybe<
													{ __typename?: 'Package' } & Pick<Types.Package, 'id' | 'shortName'>
												>;
											}
									>
								>;
							};
						availableTo?: Types.Maybe<
							Array<
								{ __typename?: 'AvailableTo' } & Pick<
									Types.AvailableTo,
									'availableCountDown' | 'availableToDate'
								> & { package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'shortName'> }
							>
						>;
					});
	};

export const NewTitleGraphqlFragmentDoc = gql`
	fragment NewTitleGraphql on NewTitlesEdge {
		cursor
		newOffer(platform: $platform) {
			id
			standardWebURL
			package {
				id
				packageId
				clearName
				shortName
			}
			retailPrice(language: $language)
			retailPriceValue
			lastChangeRetailPrice(language: $language)
			lastChangeRetailPriceValue
			lastChangePercent
			currency
			presentationType
			monetizationType
			newElementCount
		}
		node {
			id
			objectId
			objectType
			content(country: $country, language: $language) {
				title
				fullPath
				scoring {
					imdbScore
				}
				posterUrl(profile: $profile, format: $format)
				... on SeasonContent {
					seasonNumber
				}
				upcomingReleases @include(if: $showDateBadge) {
					releaseDate
					package {
						id
						shortName
					}
					releaseCountDown(country: $country)
				}
				isReleased
			}
			availableTo(country: $country, platform: $platform, packages: $availableToPackages)
				@include(if: $showDateBadge) {
				availableCountDown(country: $country)
				package {
					id
					shortName
				}
				availableToDate
			}
			... on Movie {
				likelistEntry {
					createdAt
				}
				dislikelistEntry {
					createdAt
				}
				seenlistEntry {
					createdAt
				}
				watchlistEntry {
					createdAt
				}
			}
			... on Season {
				show {
					id
					objectId
					objectType
					content(country: $country, language: $language) {
						title
					}
					likelistEntry {
						createdAt
					}
					dislikelistEntry {
						createdAt
					}
					watchlistEntry {
						createdAt
					}
					seenState(country: $country) {
						progress
					}
				}
			}
		}
	}
`;
